import { WidgetEditor } from '../constants';

import { Widget } from '../store/models';
import { IWidgetEditorAction } from '../interfaces/actions';

export const editWidget = (widgetId: string): IWidgetEditorAction => ({ 
    type: WidgetEditor.EDIT, 
    payload: { open: true, widgetId }
});

export const open = (widget: Widget): IWidgetEditorAction => ({ type: WidgetEditor.OPEN });
export const close = (widget: Widget): IWidgetEditorAction => ({ type: WidgetEditor.CLOSE });


// WEBPACK FOOTER //
// ./src/actions/WidgetEditor.ts